import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';

const routes: Routes = [
  { path: 'sign-in', loadChildren : () => import('./sign-in/sign-in.module').then(m => m.SignInModule) },
  { path: 'home', loadChildren : () => import('./home/home.module').then(m => m.HomeModule), canActivate: [AuthGuard] },
  { path: 'device', loadChildren : () => import('./home/home.module').then(m => m.HomeModule), canActivate: [AuthGuard] },
  { path: 'device/:userid/:businessprofileid', loadChildren : () => import('./home/home.module').then(m => m.HomeModule), canActivate: [AuthGuard] },
  { path: '', redirectTo: 'sign-in', pathMatch: 'full' },
  { path: '**', loadChildren : () => import('./sign-in/sign-in.module').then(m => m.SignInModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
